import type { BetterDoc, ResolvedBetterDocUsage } from "@/types/__generated__/union-types"

export const toResolvedBetterDocUsage = (betterDocUsage: BetterDoc | null): ResolvedBetterDocUsage | null =>
  betterDocUsage === "CONDITION_PACKAGE" ? null : betterDocUsage
